module.exports = __webpack_public_path__ + "static/img/egg_g_12.3381964.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/defult/img/eggs/g/egg_g_12.png
// module id = Rjlo
// module chunks = 1